var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBrandYoutube = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9044 6.50417C22.6419 5.51667 21.8711 4.74167 20.8919 4.47917C19.1169 4 12.0003 4 12.0003 4C12.0003 4 4.88359 4 3.10859 4.47917C2.12943 4.74167 1.35859 5.51667 1.09609 6.50417C0.621094 8.29167 0.621094 12.0167 0.621094 12.0167C0.621094 12.0167 0.621094 15.7417 1.09609 17.5292C1.35859 18.5167 2.12943 19.2583 3.10859 19.5208C4.88359 20 12.0003 20 12.0003 20C12.0003 20 19.1169 20 20.8919 19.5208C21.8711 19.2583 22.6419 18.5125 22.9044 17.5292C23.3794 15.7417 23.3794 12.0167 23.3794 12.0167C23.3794 12.0167 23.3794 8.29167 22.9044 6.50417ZM9.67526 15.4V8.63333L15.6211 12.0167L9.67526 15.4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBrandYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconBrandYoutube.5219d13041eab677d6bb4ab42f3175de.svg";